import React from 'react';

import Loadable from 'react-loadable';
import {Route} from 'react-router-dom';

import LoadingSpinner from 'static/three-oh/src/components/LoadingSpinner/LoadingSpinner';

const LazyExternalEmbedContainer = Loadable({
  loader: () => import(
    /* webpackChunkName: "StandaloneExternalEmbed" */
    './components/StandaloneExternalEmbed'
  ),
  delay: 1000,
  // eslint-disable-next-line
  loading: (props) => (props.pastDelay ? <LoadingSpinner /> : null)
});

const ExternalEmbedRoute = (
  <Route
    path="/external-embeds/:slug"
    component={LazyExternalEmbedContainer}
  />
);

export default ExternalEmbedRoute;
